import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchUserInfoApi } from "../../api/api";
import { drupalSettings } from "../../utils/config";
import { useLoader } from "../Common/GeneralLoader/GeneralLoaderProvider";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const { showLoader, hideLoader } = useLoader();

  // Extract UID from drupalSettings
  const uid = drupalSettings?.user?.uid || drupalSettings?.user?.user_id;

  const fetchUserInfo = async () => {
    if (!uid) return;

    try {
      showLoader();

      const response = await fetchUserInfoApi({ uid });

      // API returns inside response.data (if ajax wrapper)
      setUserInfo(response?.data || response);

    } catch (error) {
      console.error("Error fetching user info:", error);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, [uid]);

  return (
    <UserContext.Provider value={{ userInfo, fetchUserInfo }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
